import projectData from './project-data';

/* eslint-disable import/no-unresolved */
import popWav from '!arraybuffer-loader!./83a9787d4cb6f3b7632b4ddfebf74367.wav';
import meowWav from '!arraybuffer-loader!./83c36d806dc92327b9e7049a565c6bff.wav';
import ohbotOhbot from '!arraybuffer-loader!./ohbot.wav';
import ohbotSmash from '!arraybuffer-loader!./smash.wav';
import ohbotFanfare from '!arraybuffer-loader!./fanfare.wav';
import ohbotSpring from '!arraybuffer-loader!./spring.wav';
import ohbotLoop from '!arraybuffer-loader!./loop.wav';
import backdrop from '!raw-loader!./cd21514d0531fdffb22204e0ec5ed84a.svg';
import costume1 from '!raw-loader!./b7853f557e4426412e64bb3da6531a99.svg';
import costume2 from '!raw-loader!./e6ddc55a6ddd9cc9d84fe0b4c21e016f.svg';
import costume3 from '!raw-loader!./5e1f4ac0caf202c5c50cfd7297d793d7.svg';
import costume4 from '!raw-loader!./b7853f557e4426412e64bb3da6531a92.svg';
import costume5 from '!raw-loader!./47ec9ea875abcc265623617a3681325b.svg';
/* eslint-enable import/no-unresolved */

const defaultProject = translator => {
    let _TextEncoder;
    if (typeof TextEncoder === 'undefined') {
        _TextEncoder = require('text-encoding').TextEncoder;
    } else {
        /* global TextEncoder */
        _TextEncoder = TextEncoder;
    }
    const encoder = new _TextEncoder();

    const projectJson = projectData(translator);
    return [{
        id: 0,
        assetType: 'Project',
        dataFormat: 'JSON',
        data: JSON.stringify(projectJson)
    }, {
        id: '83a9787d4cb6f3b7632b4ddfebf74367',
        assetType: 'Sound',
        dataFormat: 'WAV',
        data: new Uint8Array(popWav)
    }, {
        id: '83c36d806dc92327b9e7049a565c6bff',
        assetType: 'Sound',
        dataFormat: 'WAV',
        data: new Uint8Array(meowWav)
    }, {
        id: '83c36d806dc92327b9e7049a565c6bfa',
        assetType: 'Sound',
        dataFormat: 'WAV',
        data: new Uint8Array(ohbotOhbot)
    }, {
        id: '83c36d806dc92327b9e7049a565c6bfb',
        assetType: 'Sound',
        dataFormat: 'WAV',
        data: new Uint8Array(ohbotSmash)
    }, {
        id: '83c36d806dc92327b9e7049a565c6bfc',
        assetType: 'Sound',
        dataFormat: 'WAV',
        data: new Uint8Array(ohbotSpring)
    }, {
        id: '83c36d806dc92327b9e7049a565c6bfd',
        assetType: 'Sound',
        dataFormat: 'WAV',
        data: new Uint8Array(ohbotLoop)
    }, {
        id: '83c36d806dc92327b9e7049a565c6bfe',
        assetType: 'Sound',
        dataFormat: 'WAV',
        data: new Uint8Array(ohbotFanfare)
    }, {
        id: 'cd21514d0531fdffb22204e0ec5ed84a',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(backdrop)
    }, {
        id: '47ec9ea875abcc265623617a3681325b',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(costume5)
        },
        {
        id: 'b7853f557e4426412e64bb3da6531a99',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(costume1)
        },
        {
        id: '5e1f4ac0caf202c5c50cfd7297d793d7',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(costume3)
        },
        {
        id: 'b7853f557e4426412e64bb3da6531a92',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(costume4)
        },{
        id: 'e6ddc55a6ddd9cc9d84fe0b4c21e016f',
        assetType: 'ImageVector',
        dataFormat: 'SVG',
        data: encoder.encode(costume2)
    }];
};

export default defaultProject;
